import React from 'react'
import styled from '@emotion/styled'
import { gsColors as c } from '../../styles/Variables'
import { mq } from '../../helpers'

const SummaryWrapper = styled.div`
  background-color: ${c.khaki};
  border-radius: 8px;
  padding: 24px 28px;
  margin: 0 0 40px;

  ${mq('max', '800px')} {
    padding: 20px;
    margin: 0 0 32px;
  }

  .label {
    display: block;
    margin-bottom: 8px;
    color: ${c.cobalt};
    font-family: Euclid;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  p {
    margin: 0;
    color: ${c.black};
    font-family: Euclid;
    font-size: 18px;
    font-style: italic;
    font-weight: 400;
    line-height: 150%;
    white-space: pre-wrap;

    ${mq('max', '800px')} {
      font-size: 16px;
    }
  }
`

/**
 * Renders a blog post's plain-text `summary` (TLDR) as a styled lead-in block.
 * Shows a "TL;DR" label above the text. Renders nothing when summary is empty/whitespace.
 */
export default function BlogSummary({ summary }) {
  if (!summary || !summary.trim()) {
    return null
  }

  return (
    <SummaryWrapper>
      <span className='label'>TL;DR</span>
      <p>{summary}</p>
    </SummaryWrapper>
  )
}
